import { render, staticRenderFns } from "./wCheckbox.vue?vue&type=template&id=81561d8e&scoped=true&"
import script from "./wCheckbox.vue?vue&type=script&lang=js&"
export * from "./wCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81561d8e",
  null
  
)

export default component.exports